import React from "react";
import { Link } from "react-router-dom";
import LegalDocumentPage from "@/components/LegalDocumentPage";

const TERMS_SECTIONS = [
  { heading: "Effective Date", content: "August 5, 2026" },
  { heading: "Introduction", content: "These Terms govern the use of ShowMeLive, owned by Emerging Technology LLC." },
  { heading: "Eligibility", content: "Content Creators must be 18 years of age or older." },
  {
    id: "creator-compensation",
    heading: "Creator Compensation",
    content: "Creators receive 80% of gross receipts with no payment-processing fees deducted from their share. ShowMeLive covers payment-processing fees from its 20% share. Amounts may be withheld or adjusted for refunds, disputes, fraud review, tax obligations, or other legally permitted holds.",
  },
  {
    id: "viewer-credits",
    heading: "Viewer Credits",
    content: "Viewers may purchase prepaid ShowMeLive credits in available packages and use them for tips or tithes without a separate card charge for each contribution. Credits are a closed-loop balance usable only on ShowMeLive, are not transferable, do not accrue interest, and have no cash value to the viewer except where required by law. Refunds and balance corrections are subject to these Terms, applicable law, and whether credits have already been spent.",
  },
  {
    id: "ticket-refunds",
    heading: "Ticket Refund Window",
    content: "A viewer may submit a standard ticket refund request only before 55% of the event's scheduled duration has elapsed. At and after that cutoff, the standard refund option closes. During an active livestream, a viewer who reports an event through ShowMeLive's Report feature may receive an automatic refund under the live-report process. Event cancellations, payment errors, and rights required by applicable law remain subject to separate review or processing.",
  },
  {
    id: "prohibited-content",
    heading: "Prohibited Content",
    content: "Nudity, pornography, sexually explicit content, graphic violence, credible threats, dangerous acts, hate speech, targeted harassment, fraud, deceptive schemes, spam, scams, illegal content, and content that creates a serious risk of harm are prohibited. ShowMeLive may stop or remove an event, restrict an account, withhold disputed payouts where permitted by law, and permanently ban serious or repeat violators. Fees paid by a Content Creator for a prohibited event may not be refunded.",
  },
  {
    id: "live-content-reports-and-automatic-termination",
    heading: "Live Content Reports and Automatic Termination",
    content: "Authenticated viewers may report an active livestream by selecting a report category. If 10 distinct viewer accounts submit the same report category during the same live event, ShowMeLive automatically stops the stream as a precaution and notifies the Content Creator with the reported category and applicable policy links. An automatic stop is not, by itself, a final determination that a violation occurred. ShowMeLive may review the reports, event records, and available evidence before further account or payout action. Coordinated, fraudulent, retaliatory, or knowingly false reports are prohibited and may result in account restrictions.",
  },
  {
    heading: "Unauthorized Recording",
    content: "Recording, screenshots, or redistribution are prohibited. Viewers violating this policy will be removed and will not receive any refund.",
  },
  {
    heading: "Copyright and DMCA",
    content: (
      <>
        Users may upload or broadcast only content they own or are authorized to use. ShowMeLive may
        remove content and terminate repeat infringers. Copyright notices and counter-notices must
        follow the procedure in our{" "}
        <Link className="font-semibold text-blue-400 hover:text-blue-300" to="/copyright-dmca">
          Copyright and DMCA Policy
        </Link>.
      </>
    ),
  },
  {
    heading: "Chargeback Protection",
    content: "Fraudulent chargebacks may result in account suspension, recovery of costs, and legal action.",
  },
  {
    heading: "Indemnification",
    content: "Users agree to indemnify Emerging Technology LLC for claims arising from their conduct or content.",
  },
  {
    heading: "Arbitration",
    content: "Disputes must be resolved through binding arbitration in Jackson County, Missouri. Jury trials and class actions are waived.",
  },
  { heading: "Governing Law", content: "Missouri law governs these Terms." },
];

const Terms = () => (
  <LegalDocumentPage
    title="ShowMeLive Terms of Service and Legal Agreement"
    sections={TERMS_SECTIONS}
    testId="terms-page"
  />
);

export default Terms;
